package com.nonopn.skydome.common.app.pages.estimate

import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Checkbox
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.nonopn.skydome.common.app.home.HotPreviewApp
import com.nonopn.skywatcher.common.app.res.Res
import com.nonopn.skywatcher.common.app.res.estimate_choose_a_date
import com.nonopn.skywatcher.common.app.res.estimate_side_effect_activated_now
import com.nonopn.skywatcher.common.app.res.estimate_side_effect_activated_with_deadline
import com.nonopn.skywatcher.common.app.res.estimate_side_effect_deactivated
import com.nonopn.skywatcher.common.app.res.estimate_use_end_date
import com.nonopn.skywatcher.design.local.LocalFontSizes
import com.nonopn.skywatcher.design.utils.localized
import com.nonopn.skywatcher.design.widgets.DatePickerDialog
import com.nonopn.skywatcher.design.widgets.DefaultCard
import com.nonopn.skywatcher.design.widgets.defaultCardBackground
import com.nonopn.skywatcher.design.widgets.endOfDay
import com.nonopn.skywatcher.design.widgets.startOfDay
import de.drick.compose.hotpreview.HotPreview
import eu.codlab.compose.widgets.CustomOutlinedButton
import eu.codlab.compose.widgets.TextNormal
import korlibs.time.DateFormat
import korlibs.time.DateTimeTz

@Composable
fun EstimateEndDateSelection(
    modifier: Modifier,
    model: EstimateScreenModel
) {
    val state by model.states.collectAsState()

    Row(
        modifier = modifier,
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(8.dp)
    ) {
        TextNormal(
            modifier = Modifier.weight(1f),
            text = Res.string.estimate_use_end_date.localized(),
            fontSize = LocalFontSizes.current.map.activityLightning
        )

        Checkbox(
            checked = state.isWithEndDate,
            onCheckedChange = {
                model.setIsWithAndEndDate(it)
            }
        )
    }

    if (state.isWithEndDate) {
        EstimateEndDateSelectionButton(
            modifier = Modifier.padding(8.dp),
            state.selectedEndDate
        ) { model.setSelectedEndDate(it) }
    }
}

@Composable
fun EstimateSideEffectExplanation(
    modifier: Modifier,
    model: EstimateScreenModel
) {
    val state by model.states.collectAsState()

    Row(
        modifier = modifier,
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(8.dp)
    ) {
        TextNormal(
            text = when {
                state.areEnabled && state.isWithEndDate && state.selectedEndDate != null ->
                    Res.string.estimate_side_effect_activated_with_deadline

                state.areEnabled -> Res.string.estimate_side_effect_activated_now

                else -> Res.string.estimate_side_effect_deactivated
            }.localized(),
            fontSize = LocalFontSizes.current.map.activityLightning
        )
    }
}

@Composable
private fun EstimateEndDateSelectionButton(
    modifier: Modifier,
    selectedDateTimeTz: DateTimeTz?,
    onDateSelected: (DateTimeTz) -> Unit
) {
    var showDateSelection by remember { mutableStateOf(false) }
    var selectedDate by remember { mutableStateOf(selectedDateTimeTz) }

    LaunchedEffect(selectedDateTimeTz) {
        selectedDate = selectedDateTimeTz
    }

    if (showDateSelection) {
        DatePickerDialog(
            selectedDate,
            onDismiss = {
                showDateSelection = false
            }
        ) {
            println("selected date ${it.endOfDay.format(DateFormat.FORMAT1)}")
            onDateSelected(it.startOfDay)
            showDateSelection = false
        }
    }

    val color = defaultCardBackground()

    DefaultCard(
        modifier = modifier,
        backgroundColor = color,
        columnModifier = Modifier
    ) {
        Row(
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.Center
        ) {
            CustomOutlinedButton(
                onClick = { showDateSelection = true }
            ) {
                TextNormal(
                    selectedDate?.format(DateFormat.FORMAT_DATE)
                        ?: Res.string.estimate_choose_a_date.localized(),
                )
            }
        }
    }
}

@Composable
@HotPreview(widthDp = 600, heightDp = 400, darkMode = true)
@HotPreview(widthDp = 600, heightDp = 400, darkMode = false)
private fun Preview() {
    HotPreviewApp(
        Modifier.fillMaxSize().padding(10.dp),
        isDarkTheme = isSystemInDarkTheme()
    ) {
        EstimateEndDateSelection(
            Modifier.fillMaxSize(),
            FakeEstimateScreenModel()
        )
    }
}
